import React from 'react'
import './Login.css'
import {Button} from "@material-ui/core"
import { auth } from 'firebase'
import { provider } from './firebase'
import { useStateValue } from './StateProvider'
import { actionTypes } from './reducer'
 
function Login() {

    const [{}, dispatch] = useStateValue();


    const signIn = ()=>{
        auth().signInWithPopup(provider)
        .then(result=>{
            console.log("result", result)
            dispatch({
                type: actionTypes.SET_USER,
                user: result.user
            })
        })
        .catch(err=>{
            console.log("error",err)
        })
    }
    return (
        <div className="login">
            <div className="login__container">
            <img className="login__logo" src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt=""/>    
            <div className="login__text">
                <h1>Sign in to whatsapp</h1>
            </div>
            <Button type="submit" onClick={signIn}>
                SIGN IN WITH GOOGLE
            </Button>    
            </div>
        </div>

    )
}

export default Login
